import { Schema as S } from "effect";
export const Schema = S.Number.pipe(S.brand("@open-revenue/schema/stripe/UnitAmount"), S.annotations({
    identifier: "@open-revenue/schema/stripe/UnitAmount",
    description: "The unit amount of the invoice line in Stripe. You must know the presentment unit amount to use this for getting back to cents/zeros",
    examples: [
        1000
    ]
}));
export const make = (unitAmount)=>S.decodeUnknown(Schema)(unitAmount);
export const makeUnsafe = (unitAmount)=>unitAmount;
